// Import SASS
import '../sass/style.scss';

// Import scripts
// import './modules/navigation';
import './modules/skip-link-focus-fix';
import objectFitImages from 'object-fit-images';
import { tns } from 'tiny-slider/src/tiny-slider';
import baguetteBox from 'baguettebox.js';


// Hamburger menu
document.querySelector("#nav-toggle").addEventListener("click", function() {
	let body = document.querySelector('body');
	let nav = document.querySelector('.header__nav');
	let mainNav = document.querySelector('.main-navigation');
	this.classList.toggle("active");
	mainNav.classList.toggle('toggled');
	nav.classList.toggle('toggled');
	body.classList.toggle('toggled');
});

// Object-fit fix
objectFitImages();

if ( document.querySelector('.hero-slider') ) {

	const heroSlider = tns({
		container: '.hero-slider',
		items: 1,
		mouseDrag: true,
		controls: false,
		nav: false,
		lazyload: true,
		autoplay: true,
		autoplayButtonOutput: false,
	});

	let prev = document.querySelector('.js-slider-prev');
	let next = document.querySelector('.js-slider-next');

	prev ? prev.onclick = () => { heroSlider.goTo('prev'); } : '';
	next ? next.onclick = () => { heroSlider.goTo('next'); } : '';

}

// Gallery
baguetteBox.run('.gallery', {
	animation: 'fadeIn',
    noScrollbars: true
});